import LegalLayout, { LegalSection, LegalBullet } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      testId="terms-page"
      eyebrow="the fine print. in blood."
      title="TERMS OF"
      accent="SERVICE"
      updated="Last updated: September 2026"
    >
      <LegalSection num="I" title="Acceptance of Terms">
        <p>
          By accessing or using the Atrocity Comix website (the "Site"), operated by Atrocity Comix
          ("we", "us", "our"), you agree to be bound by these Terms of Service. If you do not agree
          with any part of these terms, do not use the Site. We may update these terms from time to
          time; continued use of the Site after changes are posted constitutes acceptance.
        </p>
      </LegalSection>

      <LegalSection num="II" title="Age Requirement">
        <p>
          This Site contains mature comic book content, including horror, violence, and suggestive
          imagery. You must be at least 18 years of age (or the age of majority in your
          jurisdiction) to use this Site. By entering, you confirm that you meet this requirement.
          We reserve the right to refuse service to anyone who does not.
        </p>
      </LegalSection>

      <LegalSection num="III" title="Accounts">
        <ul className="space-y-2">
          <LegalBullet>
            You may create an account with your name, email address, and a password. You must meet
            the age requirement above to hold an account.
          </LegalBullet>
          <LegalBullet>
            Keep your password confidential. You are responsible for all activity that happens
            under your account, so choose a password you don't use anywhere else.
          </LegalBullet>
          <LegalBullet>
            Orders placed with your account email appear in your account's order history, and your
            want-list of hearted items is saved to your account.
          </LegalBullet>
          <LegalBullet>
            We may suspend or terminate accounts that violate these terms. You may request account
            deletion at any time by emailing us.
          </LegalBullet>
        </ul>
      </LegalSection>

      <LegalSection num="IV" title="Intellectual Property">
        <p>
          All content on this Site — including comic art, covers, characters (including Mary
          Machinegun, Human Hunters, Ninja Bimbos, Dark America, and Fran Cord), logos, text, and
          design — is the property of Atrocity Comix or its licensors and is protected by copyright
          and trademark law. You may not reproduce, distribute, modify, or create derivative works
          from any content without our prior written permission.
        </p>
      </LegalSection>

      <LegalSection num="V" title="Products and Orders">
        <ul className="space-y-2">
          <LegalBullet>
            We sell physical comics, digital comics, and collectible prints. Product descriptions,
            prices, and availability are subject to change without notice.
          </LegalBullet>
          <LegalBullet>
            We reserve the right to refuse or cancel any order, including orders with pricing or
            listing errors. If your order is cancelled after payment, you will receive a full
            refund.
          </LegalBullet>
          <LegalBullet>
            Physical items ship to the address provided at checkout. Risk of loss passes to you upon
            delivery to the carrier.
          </LegalBullet>
        </ul>
      </LegalSection>

      <LegalSection num="VI" title="Digital Goods License">
        <p>
          Unless otherwise stated, digital comics are licensed, not sold. Your purchase grants you a
          non-exclusive, non-transferable license for personal, non-commercial use. You may not
          redistribute, resell, share, or upload digital files to any public or private sharing
          service.
        </p>
      </LegalSection>

      <LegalSection num="VII" title="Creator Submissions">
        <p>
          Work submitted through our submissions process is governed by our{" "}
          <a href="/submissions" className="text-bloodglow underline decoration-blooddeep underline-offset-4 hover:text-crimson transition-colors duration-150">
            Submissions Policy
          </a>
          . Submitting work for review does not transfer ownership; rights remain with the creator
          unless a publishing agreement is signed.
        </p>
      </LegalSection>

      <LegalSection num="VIII" title="Acceptable Use">
        <p>You agree not to:</p>
        <ul className="space-y-2">
          <LegalBullet>Use the Site for any unlawful purpose or in violation of any regulations.</LegalBullet>
          <LegalBullet>Attempt to gain unauthorized access to the Site or its systems.</LegalBullet>
          <LegalBullet>Scrape, harvest, or collect information from the Site by automated means.</LegalBullet>
          <LegalBullet>Interfere with the operation of the Site or other users' enjoyment of it.</LegalBullet>
        </ul>
      </LegalSection>

      <LegalSection num="IX" title="Disclaimers and Limitation of Liability">
        <p>
          The Site and its content are provided "as is" without warranties of any kind, express or
          implied. To the fullest extent permitted by law, Atrocity Comix shall not be liable for
          any indirect, incidental, or consequential damages arising from your use of the Site or
          purchase of products. Our total liability shall not exceed the amount you paid us in the
          twelve months preceding the claim.
        </p>
      </LegalSection>

      <LegalSection num="X" title="Governing Law and Changes">
        <p>
          These terms are governed by the laws of the jurisdiction in which Atrocity Comix operates,
          without regard to conflict-of-law principles. We may revise these terms at any time; the
          current version will always be posted on this page with its revision date.
        </p>
      </LegalSection>

      <LegalSection num="XI" title="Contact">
        <p>
          Questions about these Terms of Service may be sent to{" "}
          <span className="text-bloodglow font-courier">atrocitycomix@atrocitycomix.com</span>.
        </p>
        <p className="font-marker text-bloodglow text-lg rotate-[-1deg] inline-block mt-2">
          — The Atrocity Comix Editorial Team
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
